import { Component, OnInit } from '@angular/core';

//jquery declaration
declare var $: any;

@Component({
  selector: 'app-safetyvideos',
  templateUrl: './safetyvideos.component.html',
  styleUrls: ['./safetyvideos.component.css']
})
export class SafetyvideosComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
    this.topposition();
  }

  topposition(){  

    // if ($('#preloader').length) {
    //   $('#preloader').delay(500).fadeOut('slow', function() {
    //     $(this).remove();
    //   });
    // }
    $('html, body').animate({
      scrollTop: 0
    }, 1000, 'easeInOutExpo');
    
    return false;
  }

}
